import * as React from 'react';
import Tooltip from 'components/Tooltip';

type Props = {
  label: string,
  tooltip: string
};

const MetricLabelWithTooltip = (
  {
    label,
    tooltip
  }: Props
): JSX.Element => (
  <span className="channel-metrics__tooltip-label">
    {label} <Tooltip message={tooltip} width="long" showQuestionMark />
  </span>
);

export default MetricLabelWithTooltip;
